import React, { forwardRef } from 'react';

interface GlassProps {
  classes?: string;
  style?: React.CSSProperties;
}

export const Glass = forwardRef<HTMLElement, GlassProps>(({ classes, style = {} }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-magnifying-glass ${classes || ''}`} style={style}></i>
  );
});

Glass.displayName = 'Glass';
